import { css } from '@linaria/core'
import { style } from '#styles/index'

export const inputCss = `
  padding: 4px 8px;
  min-height: 30px;
  color: ${style.theme.textDefault};
  background-color: ${style.theme.backgroundSurfacePrimary};
  border: 1px solid ${style.theme.borderInput};
  outline: 2px solid transparent;
  outline-offset: -2px;
  transition: 0.25s ease border-color, 0.25s ease outline-color, 0.25s ease color;
  display: flex;
  align-items: center;

  &::placeholder {
    color: ${style.theme.textSoft};
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &:hover {
    border-color: ${style.theme.borderHover}
  }

  &:focus {
    outline-color: ${style.theme.borderOutline};
    border-color: ${style.theme.borderOutline};
  }

  &:disabled {
    pointer-events: none;
    border-color: ${style.theme.borderDisabled};
    color: ${style.theme.textDisabled};
    background: ${style.theme.backgroundSurfaceDisabled};
  }

  &.without-label {
    margin-top: 20px;
  }
  
  &.without-error {
    margin-bottom: 20px;
  }
  
  &.slim, &.without-error.slim, &.without-label.slim, &.without-label.without-error.slim {
    margin-bottom: 0;
    margin-top: 0;
  }

  &.with-error {
    border-color: ${style.theme.borderDanger};
    &:hover {
      border-color: ${style.theme.borderHover};
    }
    &:focus {
      outline-color: ${style.theme.borderDanger};
    }
  }
`

export const inputCssClass = css`${inputCss}`
